import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_ORDER_UPCHARGE_SUMMARY } from '@/graphql/queries';
import usePDPOrderEdit from 'data-hooks/usePDPOrderEdit';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import { logError } from 'commons/logger';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPCompleteOrderUI from './PDPCompleteOrderUI';
import useResetPdpEditOrderErrorMessage from '../state/pdpEditOrderErrorMessage/useResetPdpEditOrderErrorMessage';
import PDPCompleteOrderPlaceholder from './PDPCompleteOrderPlaceholder';
const PDPCompleteOrderInner = () => {
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const {
    data: {
      orderId,
      cartItem,
      orderInfo,
      selectedProductOptions
    },
    actions: {
      updateOrder
    },
    error: ordersError
  } = usePDPOrderEdit();
  const resetPdpEditOrderErrorMessage = useResetPdpEditOrderErrorMessage();
  const {
    data: {
      selectedMaterial
    }
  } = usePDPFabricFilters(null, true);
  const [getOrderUpChargeSummary, {
    data: summaryData,
    loading: summaryLoading
  }] = useLazyQuery(GET_ORDER_UPCHARGE_SUMMARY, {
    fetchPolicy: 'network-only',
    onCompleted: async data => {
      try {
        setLoading(true);
        if (data?.getOrderItemUpChargeSummary?.summary) {
          if (data.getOrderItemUpChargeSummary.summary.grand_total_diff > 0) {
            setShowModal(true);
          } else {
            await updateOrder({
              grandTotal: 0
            });
          }
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        logError(e);
      }
    }
  });
  const onCompletedOrderClick = async () => {
    resetPdpEditOrderErrorMessage();
    await getOrderUpChargeSummary({
      variables: {
        input: {
          order_id: orderId,
          cart_item_id: cartItem.cart_id,
          productOptions: selectedProductOptions
        }
      }
    });
  };
  if (ordersError) {
    return null;
  }
  return <PDPCompleteOrderUI cartItem={cartItem} isChecked={isChecked} loading={loading || summaryLoading} onCompletedOrderClick={onCompletedOrderClick} orderId={orderId} orderInfo={orderInfo} orderUpChargeSummaryData={summaryData?.getOrderItemUpChargeSummary} selectedMaterial={selectedMaterial} setIsChecked={setIsChecked} setShowModal={setShowModal} showModal={showModal} updateOrder={updateOrder} />;
};
const PDPCompleteOrder = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPCompleteOrderPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPCompleteOrderInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPCompleteOrder;